let productId = document.currentScript.getAttribute('product-id'), noImage = document.currentScript.getAttribute('no-image'),spinnerImage = document.currentScript.getAttribute('spinner-image'), printCSS = document.currentScript.getAttribute('print-css'), productJSON = document.currentScript.getAttribute('product-json');

window.GB_OUTDOOR_FURNITURE = function () {
	return {
		config: {
			API_BASE_URL: "https://gb-outdoor-furniture-api.herokuapp.com/api/2022-10",
			PDF_API_URL: "https://phpstack-869524-3236862.cloudwaysapps.com"
		},
		init: async function () {
			try {
				const productRes = await fetch(`https://gb-outdoor-furniture-api.herokuapp.com/api/2022-10/api/storefront/${productId}/products`).then((response) => response.json());
				productRes?.success == "true" && (window.GB_OUTDOOR_FURNITURE.config.productData = productRes?.data);
				window?.GB_OUTDOOR_FURNITURE?.initSection();
			} catch (error) {
				console.log(error);
			}
		},
		handleize: function (str) {
			str = str.toLowerCase();
		
			var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
			
			// For the old browsers
			for (var i = 0; i < toReplace.length; ++i) {
				str = str.replace(toReplace[i], "");
			}
		
			str = str.replace(/\W+/g, "-");
		
			if (str.charAt(str.length - 1) == "-") {
				str = str.replace(/-+\z/, "");
			}
		
			if (str.charAt(0) == "-") {
				str = str.replace(/\A-+/, "");
			}
		
			return str;
		},
		removeCheckedSubOption: function () {
			if (document.getElementsByClassName('sub_options')?.length > 0) {	
				let rmSubOptionElements = document.getElementsByClassName('sub_options');
				rmSubOptionElements = Array.prototype.slice.call(rmSubOptionElements);
				for (let i = 0; i < rmSubOptionElements?.length; i++) {
					rmSubOptionElements[i].checked = false;
			   	}
			}

			if (document.getElementsByClassName('border_round')?.length > 0) {	
				let labelSubOptionElements = document.getElementsByClassName('border_round');
				labelSubOptionElements = Array.prototype.slice.call(labelSubOptionElements);
				for (let i = 0; i < labelSubOptionElements?.length; i++) {
					labelSubOptionElements[i].classList.remove('border_round');
			   	}
			}
		},
		addClassOnLabelSubOption: function () {
			if (document.getElementsByClassName('sub_options')?.length > 0) {	
				let rmSubOptionElements = document.getElementsByClassName('sub_options');
				rmSubOptionElements = Array.prototype.slice.call(rmSubOptionElements);
				for (let i = 0; i < rmSubOptionElements?.length; i++) {
					rmSubOptionElements[i].addEventListener('click', function () {
                     
                      
						// window.GB_OUTDOOR_FURNITURE.removeCheckedSubOption();
						const nameTag = this.getAttribute('name');
						if (document.querySelectorAll('[name="'+nameTag+'"]')) {
							let nameTagElements = document.querySelectorAll('[name="'+nameTag+'"]');
							nameTagElements = Array.prototype.slice.call(nameTagElements);
                  
							for (let i = 0; i < nameTagElements?.length; i++) {
								nameTagElements[i].checked = false;
								nameTagElements[i].parentElement.classList.remove('border_round');
							}
						}
						this.parentElement.classList.add('border_round');
					});
			   	}
			}
		},
		initTabButtonEvent: function () {
			let optionsTabElements = document.getElementsByClassName('options_tab');
			optionsTabElements = Array.prototype.slice.call(optionsTabElements);
			if (optionsTabElements?.length > 0) {
            
				for (let i = 0; i < optionsTabElements?.length; i++) {
					const element = optionsTabElements[i];
                
					element.addEventListener('click', function (e) {
						const value = this.getAttribute('data-option') || "";
						window?.GB_OUTDOOR_FURNITURE?.removeCheckedSubOption();
						if (value?.length > 0) {
							const dClass = window.GB_OUTDOOR_FURNITURE.handleize(value);
							if (document.getElementsByClassName(`${dClass}_option`)?.length > 0) {	
								let SubOptionElements = document.getElementsByClassName(`${dClass}_option`);
								SubOptionElements = Array.prototype.slice.call(SubOptionElements);
                             
								for (let i = 0; i < SubOptionElements?.length; i++) {
									if (i == 0) {
										SubOptionElements[i].checked = true;
										// SubOptionElements[i].parentElement.classList.add('border_round');
									}
							   	}
							}
						}
					});
				}
			}
		},
		initSection: function () {
			if (document.querySelector('[data-home-our-products]') && window?.GB_OUTDOOR_FURNITURE?.config?.productData != null && Object.keys(window?.GB_OUTDOOR_FURNITURE?.config?.productData)?.length >0) {
				const dataHomeOurProductsElement = document.querySelector('[data-home-our-products]'), productResult = window?.GB_OUTDOOR_FURNITURE?.config?.productData;
				const optionUnique = _.map(_.uniqBy(window?.GB_OUTDOOR_FURNITURE?.config?.productData?.ProductRules, (e) => e.option_type_name),'option_type_name');
				const optionGrouped = _.mapValues(_.groupBy(productResult?.ProductRules, 'option_type_name'), oList => oList.map(option => _.omit(option, 'option_type_name')));
                 console.log(optionUnique);  

				if (optionUnique?.length > 0) {
					let html = '';
				//	html += `<h2>${productResult?.section_name}:</h2>`;
                    html += `<h2>Finishes:</h2>`;
					html += '<div class="discraption_amd_collection_tabing">';
						html += '<div class="tab">';
							for (let i = 0; i < optionUnique?.length; i++) {
                                                      
								let itm = optionUnique[i];
								                                                          
								if (!_.isNull(optionUnique[i])) {
                                    let itm1 = itm.replace(" ", "-");   
									html += `<button class="tablinks options_tab${(i==0 ? ' active':'')}" data-option="${optionUnique[i]}" onclick="show_product(event ,'q${itm1}')">${optionUnique[i]}</button>`;	
								}
							}
						html += '</div>';

						for (let j = 0; j < optionUnique?.length; j++) {                  
							const option = optionUnique[j];														
							if (optionGrouped[option]?.length > 0 && !_.isNull(option)) {
                              let itm1 = option.replace(" ", "-");
								html += `<div id="q${itm1}" class="tabcontent${(j==0 ? ' showtab':' hidetab')} ${itm1}">`;
									html += `<div class="description_pdp">`;
										if (optionGrouped[option]?.length >12) {
											html += `<swiper-container class="mySwiper" grid-rows="2" pagination="true" pagination-clickable="true" slides-per-view="4" slides-per-group="4" space-between="0" style="--swiper-pagination-color: #7ca88e;">`;
											for (let v = 0; v < optionGrouped[option]?.length; v++) {
												var optionValues = optionGrouped[option][v];
												if (!_.isNull(optionValues?.option_value_name)) {											
													var dynamicId = window.GB_OUTDOOR_FURNITURE.handleize(`${option} ${optionValues?.option_value_name}`);
													html += `<swiper-slide>`;
														html += `<label data-type="${itm1}" data-val="${optionValues?.option_value_name}" data-img="${optionValues?.option_value_image_url?.length > 0 ? optionValues?.option_value_image_url : noImage}" id="border_round${v}" for="${dynamicId}" class="checkCls ${v == 0 ? '' : ''}">`; //border_round
															html += `<input type="radio" id="${dynamicId}" class="${window.GB_OUTDOOR_FURNITURE.handleize(option)}_option sub_options" name="properties[${option}]" value="${option}" ${v == 0 ? 'checked' : ''} style="display: none;">`;
															html += `<div class="tabbing_box">`;
																html += `<div class="tabbing_box_image">`;
																	html += `<img src="${optionValues?.option_value_image_url?.length > 0 ? optionValues?.option_value_image_url : noImage}" alt="${optionValues?.option_value_name}" data-val="${optionValues?.option_value_name}" title="${optionValues?.option_value_name}">`;
																html += `</div>`;
																html += `<div class="tabbing_box_title">`;
																	html += `<h3>${optionValues?.option_value_name}</h3>`;
																html += `</div>`;
															html += `</div>`;
														html += `</label>`;
													html += `</swiper-slide>`;
												}
											}
											html += `</swiper-container>`;
										} else {
											html += `<ul>`;
											for (let v = 0; v < optionGrouped[option]?.length; v++) {
												var optionValues = optionGrouped[option][v];
												if (!_.isNull(optionValues?.option_value_name)) {											
													var dynamicId = window.GB_OUTDOOR_FURNITURE.handleize(`${option} ${optionValues?.option_value_name}`);
													html += `<li>`;
														html += `<label  data-type="${itm1}" data-val='${optionValues?.option_value_name}''  data-img="${optionValues?.option_value_image_url?.length > 0 ? optionValues?.option_value_image_url : noImage}"  id="border_round${v}"  for="${dynamicId}" class="checkCls ${v == 0 ? '' : ''}">`; //border_round
															html += `<input type="radio" id="${dynamicId}" class="${window.GB_OUTDOOR_FURNITURE.handleize(option)}_option sub_options" name="properties[${option}]" value="${option}" ${v == 0 ? 'checked' : ''} style="display: none;">`;
															html += `<div class="tabbing_box">`;
																html += `<div class="tabbing_box_image">`;
																	html += `<img src="${optionValues?.option_value_image_url?.length > 0 ? optionValues?.option_value_image_url : noImage}" alt="${optionValues?.option_value_name}"  data-val="${optionValues?.option_value_name}"  title="${optionValues?.option_value_name}">`;
																html += `</div>`;
																html += `<div class="tabbing_box_title">`;
																	html += `<h3>${optionValues?.option_value_name}</h3>`;
																html += `</div>`;
															html += `</div>`;
														html += `</label>`;
													html += `</li>`;
												}
											}
											html += `</ul>`;
										}
									html += `</div>`;
								html += `</div>`;

								if (document.querySelectorAll('[data-pdp-options]')?.length > 0) {
									const dataPDPOptionsElements =  document.querySelectorAll('[data-pdp-options] .Aluminum, [data-pdp-options] .Fabric');                 
									for (let index = 0; index < dataPDPOptionsElements?.length; index++) {
										dataPDPOptionsElements[index].innerHTML += `<p style="display:inline-grid; grid-template-columns: 30% 40% 30%; "><span>${option}:</span><!--a href="${optionGrouped[option][0]?.option_type_link?.length > 0 ? optionGrouped[option][0]?.option_type_link : 'javascript:;'}" ${optionGrouped[option][0]?.option_type_link?.length > 0 ? 'target="_blank"' : ''}>Click to See the Options </a-->${optionValues?.option_value_name}</p><br><br><img src="${optionValues?.option_value_image_url?.length > 0 ? optionValues?.option_value_image_url : noImage}" alt="${optionValues?.option_value_name}"  data-val="${optionValues?.option_value_name}"  title="${optionValues?.option_value_name}" style="width:40px; height:40px;">`;
									 }
                               
									setTimeout(() => {
										if (document.querySelectorAll('swiper-container')?.length > 0) {
											for (let i = 0; i < document.querySelectorAll('swiper-container')?.length; i++) {
												document.querySelectorAll('swiper-container')[i].classList.remove('swiper-grid-column');
											}
										}
									}, 50);
								}
							}
						}
                
					html += '</div>';
					
					dataHomeOurProductsElement.innerHTML = html; // load Data
					// window.GB_OUTDOOR_FURNITURE.initTabButtonEvent();
					window.GB_OUTDOOR_FURNITURE.addClassOnLabelSubOption();

					if (productJSON?.length > 0) {
						productJSON = JSON.parse(productJSON);
						productJSON['options'] = optionUnique;
					}
				}

				/* Description */
				if (document.querySelectorAll('[data-pdp-detail-description]')?.length > 0 && productResult?.description?.length > 0) {
					const dataPDPDetailDescriptionElements = document.querySelectorAll('[data-pdp-detail-description]');
					let dHTML = '';
					dHTML += '<h3>Description</h3>';
					dHTML += `<p>${productResult?.description}</p>`;

					for (let i = 0; i < dataPDPDetailDescriptionElements?.length; i++) {
						dataPDPDetailDescriptionElements[i].innerHTML = dHTML;
					}
				}
				/* End */

				/* Description Images */
				if (document.querySelectorAll('[data-pdp-detail-description-image]')?.length > 0 && !_.isEmpty(productResult?.description_image_urls)) {
					const dataPDPDetailDescriptionImageElements = document.querySelectorAll('[data-pdp-detail-description-image]'), imageArray = productResult?.description_image_urls;
					let dImageHTML = '';
					imageArray?.length > 0 && imageArray?.map(function(objItem) {
						dImageHTML += `<div class="sofa_image">
							<img src="${objItem?.url?.length > 0 ? objItem?.url : noImage}" alt="" title="">
						</div>`;
					});

					for (let i = 0; i < dataPDPDetailDescriptionImageElements?.length; i++) {
						dataPDPDetailDescriptionImageElements[i].innerHTML = dImageHTML;
					}
				}
				/* End */

				/* Gallery */
				if (document.querySelector('[data-gallery-images]') && !_.isEmpty(productResult?.gallery_image_urls)) {
					if (document.querySelector('[data-gallery-title]') && productResult?.gallery_title?.length > 0) {
						document.querySelector('[data-gallery-title]').innerText = productResult?.gallery_title;
					}

					let dataGalleryImageElement = document.querySelector('[data-gallery-images]'), gImageArray = productResult?.gallery_image_urls;
					let gImageHTML = '';
					gImageArray = _.orderBy(gImageArray, ['url'], 'desc')
					gImageArray?.length > 0 && gImageArray?.map(function (gObjItem) {
						let imageURL = gObjItem?.url?.split('?'), images = [], WidthArray = [165, 360, 533, 720, 940, 1066, 1242];

						for (let i = 0; i < WidthArray?.length; i++) {
							images.push(`${imageURL[0]}?v=${Date.now()}&amp;width=${WidthArray[i]} ${WidthArray[i]}w`);
						}
						gImageHTML += `<li class="grid__item">
							<div class="card-wrapper underline-links-hoverz">
								<div class="card card--standard card--media" style="--ratio-percent: 100%;">
									<div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100%;">
										<div class="card__media">
											<div class="media media--transparent media--hover-effect">
												<img srcset="${images}" src="${imageURL[0]}?v=${Date.now()}&amp;width=533" sizes="(min-width: 1650px) 380px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="" class="motion-reduce" loading="lazy" width="1242" height="1211">
											</div>
										</div>
									</div>
								</div>
							</div>
						</li>`;
					});

					dataGalleryImageElement.innerHTML = gImageHTML;
				}
				/* End */
			}else{
				if (document.querySelector('[data-home-our-products]')) {
					document.querySelector('[data-home-our-products]').innerHTML = '';
				}
			}
		},
		printPage: function (element) {
			let displaySettings ="toolbar=yes,location=no,";
			displaySettings+="directories=yes,menubar=yes,";
			displaySettings+="scrollbars=yes,width=650, height=600, left=100, top=25";
			let myWindow = window.open("", 'Somerset LED Pendant', displaySettings);
			myWindow.document.open();
			myWindow.document.write('<html><head><link rel="stylesheet" href="'+printCSS+'" type="text/css" media="all"><title>GB Outdoor Furniture</title></head><body>');
			myWindow.document.write(document.getElementById(element).innerHTML);
			myWindow.document.close();
			myWindow.print();
		}
	}
}();

document.addEventListener('DOMContentLoaded', function (event) {
	window?.GB_OUTDOOR_FURNITURE?.init();
});

if (document.getElementById('generate-pdf')) {
	const generatePDFElement = document.getElementById('generate-pdf');
	generatePDFElement.addEventListener('click', async function () {
		const popupLoaderElement = document.querySelector('[data-popup-loader]') || "";
		if (popupLoaderElement != '') {
			popupLoaderElement.style.display = 'block';
		}

		const rawResponse = await fetch(`${window?.GB_OUTDOOR_FURNITURE?.config?.PDF_API_URL}/generate-pdf.php`, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(productJSON)
		});
		const resPayload = await rawResponse.json();
		if (resPayload?.url?.length > 0) {
			window.open(`${window?.GB_OUTDOOR_FURNITURE?.config?.PDF_API_URL}${resPayload?.url}`);
			if (popupLoaderElement != '') {
				popupLoaderElement.style.display = '';
			}
		}else{
			if (popupLoaderElement != '') {
				popupLoaderElement.style.display = 'block';
			}
		}
	});
}